module.exports = __webpack_public_path__ + "staticfr/media/marcas (2).9255b50f.png";